import kuliahPerdanaCinta5 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Cinta_5 Large.jpeg";
import kuliahPerdanaKia16 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kia_16 Large.jpeg";
import kuliahPerdanaKelvin043 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kelvin Kurniawan_043 Large.jpeg";
import kuliahPerdanaJohan36 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Johan_36 Large.jpeg";
import kuliahPerdanaThirza41 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana-Thirza-41 Large.jpeg";
import kuliahPerdanaKia06 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kia_06 Large.jpeg";
import kuliahPerdanaThirza23 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana-Thirza-23 Large.jpeg";
import kuliahPerdanaThirza11 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana-Thirza-11 Large.jpeg";
import kuliahPerdanaAndrew10 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Andrew Su-10 Large.jpeg";
import kuliahPerdanaAndrew13 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Andrew Su-13 Large.jpeg";
import kuliahPerdanaJohan31 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah-Perdana_Johan_31-Large.jpeg";
import kuliahPerdanaBernice16 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana-Bernice-16 Large.jpeg";
import kuliahPerdanaRavalen12 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Ravalen Virginia_12 Large.jpeg";
import kuliahPerdanaDevin20 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Devin Edsel_20 Large.jpeg";
import kuliahPerdanaKelvin008 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kelvin Kurniawan_008 Large.jpeg";
import kuliahPerdanaKenzie56 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kenzie Andhika Theodorus Suhanto_56 Large.jpeg";
import kuliahPerdanaStevan12 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Stevan Antonius-12 Large.jpeg";
import kuliahPerdanaKenzie10 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kenzie Andhika Theodorus Suhanto_10 Large.jpeg";
import kuliahPerdanaKenzie27 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Kenzie Andhika Theodorus Suhanto_27 Large.jpeg";
import kuliahPerdanaBernice4 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana-Bernice-4 Large.jpeg";
import kuliahPerdanaCinta15 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Cinta_15 Large.jpeg";
import kuliahPerdanaDevin24 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Devin Edsel_24 Large.jpeg";
import kuliahPerdanaStevan6 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Stevan Antonius-6 Large.jpeg";
import kuliahPerdanaRavalen07 from "../../Assets/Kuliah-Perdana-Revisi/Kuliah Perdana_Ravalen Virginia_07 Large.jpeg";

const kuliahPedana = [
  { id: 1, img: kuliahPerdanaCinta5 },
  { id: 2, img: kuliahPerdanaKia16 },
  { id: 3, img: kuliahPerdanaKelvin043 },
  { id: 4, img: kuliahPerdanaJohan36 },
  { id: 5, img: kuliahPerdanaThirza41 },
  { id: 6, img: kuliahPerdanaKia06 },
  { id: 7, img: kuliahPerdanaThirza23 },
  { id: 8, img: kuliahPerdanaThirza11 },
  { id: 9, img: kuliahPerdanaAndrew10 },
  { id: 10, img: kuliahPerdanaAndrew13 },
  { id: 11, img: kuliahPerdanaJohan31 },
  { id: 12, img: kuliahPerdanaBernice16 },
  { id: 13, img: kuliahPerdanaRavalen12 },
  { id: 14, img: kuliahPerdanaDevin20 },
  { id: 15, img: kuliahPerdanaKelvin008 },
  { id: 16, img: kuliahPerdanaKenzie56 },
  { id: 17, img: kuliahPerdanaStevan12 },
  { id: 18, img: kuliahPerdanaKenzie10 },
  { id: 19, img: kuliahPerdanaKenzie27 },
  { id: 20, img: kuliahPerdanaBernice4 },
  { id: 21, img: kuliahPerdanaCinta15 },
  { id: 22, img: kuliahPerdanaDevin24 },
  { id: 23, img: kuliahPerdanaStevan6 },
  { id: 24, img: kuliahPerdanaRavalen07 }
];

export default kuliahPedana;